export default {
  UpdateAuctionBids: 'UpdateAuctionBids',
  UpdateTransportOrderStatusHistory: 'UpdateTransportOrderStatusHistory',
  UpdateSidebarCounters: 'UpdateSidebarCounters',
};
